import React from 'react';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import { Button, Switch, Tooltip } from '@/components/ui';

interface DemoPreviewToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  disabled?: boolean;
  className?: string;
  numberOfRows?: number; // Optional: number of demo data rows to display in tooltip
}

/**
 * DemoPreviewToggle - Switch for enabling/disabling demo data in preview
 *
 * When enabled, preview modal will show demo data.
 * When disabled, preview modal will show empty template.
 */
export const DemoPreviewToggle: React.FC<DemoPreviewToggleProps> = ({
  enabled,
  onChange,
  disabled = false,
  className,
  numberOfRows,
}) => {
  const tooltipContent = enabled
    ? numberOfRows !== undefined
      ? `Preview with demo data: Preview will show sample data (${numberOfRows} rows)`
      : 'Preview with demo data: Preview will show sample data'
    : 'Preview with template: Preview will show empty template';

  return (
    <Tooltip
      content={tooltipContent}
      side="top"
    >
      <Button
        size="small"
        variant="outlined"
        color={enabled ? 'primary' : 'default'}
        as="label"
        onClick={() => {
          onChange(!enabled);
        }}
        startIcon={enabled ? <IconEye /> : <IconEyeOff />}
        endIcon={
          <Switch
            checked={enabled}
            color={enabled ? 'primary' : 'default'}
            onCheckedChange={onChange}
            disabled={disabled}
            size="small"
          />
        }
        className={className}
      >
        Preview with {enabled ? 'demo data' : 'template'}
      </Button>
    </Tooltip>
  );
};










